import { render, staticRenderFns } from "./SwiperTypeTwo.vue?vue&type=template&id=315e160a&scoped=true&"
import script from "./SwiperTypeTwo.vue?vue&type=script&lang=js&"
export * from "./SwiperTypeTwo.vue?vue&type=script&lang=js&"
import style0 from "./SwiperTypeTwo.vue?vue&type=style&index=0&id=315e160a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e160a",
  null
  
)

export default component.exports